<div class = "search-page">
  <div id = "criteria">
    <app-car-search-criteria
      [selectedBusinessLine]="businessLine!">

    </app-car-search-criteria>
  </div>
  <div id = "results">
    <!-- <h1> {{ (previewTotalCount$ | async)}} véhicules en {{ businessLine == CarBusinessLine.BUY ? 'vente' : 'location' }}</h1> -->
    <app-car-card-list
      [fetchingResults]="(fetchingResults$ | async)!"
      [cars]="carResults"
      [businessLine]="businessLine!"
      >
    </app-car-card-list>

    <div class = "paginator">
      <div class = "page-selectors">

        <mat-label class="icon-text">Items par page</mat-label>
        <mat-select class="page-size" required name = "pageSize" [(ngModel)]="pageSize" (selectionChange)="updatePageSize()">
          @for (size of pageSizeOptions; track size; let i = $index) {
            <mat-option [value]="size" >{{size}}</mat-option>
          }
        </mat-select>

      </div>
      <div class= "page-numbers">
        <button [disabled]="carCriteria.pageNumber < 1" mat-button (click)="loadPreviousPage();$event.stopPropagation()" class="pic-arrow-left"> <mat-icon>arrow_back_ios</mat-icon>  <span class="icon-text">Précédente</span></button>

        @for (pgNumber of pageNumbers; track pgNumber) {
          <button [disabled]="carCriteria.pageNumber === pgNumber" mat-button (click)="loadPage(pgNumber);$event.stopPropagation()" > {{ pgNumber+1 }} </button>
        }

        <button [disabled]="carCriteria.pageNumber >= totalItems/carCriteria.pageSize - 1" mat-button (click)="loadNextPage();$event.stopPropagation()" class="pic-arrow-right"> <span class="icon-text">Suivante</span> <mat-icon>arrow_forward_ios</mat-icon></button>
      </div>
    </div>
  </div>
</div>


